import { toValue, shallowRef, readonly } from 'vue'

const alertModalContent = shallowRef('')
const showAlertModal = shallowRef(false)

export const useAlert = () => {
  const enviromentName =
    typeof import.meta !== 'undefined' && import.meta.env
      ? import.meta.env.MODE
      : process?.env?.NODE_ENV

  const log = (msg = null) => {
    if (!msg) {
      return
    }
    if (enviromentName === 'development') {
      console.error(toValue(msg))
    } else {
      alertModalContent.value = toValue(msg)
      setTimeout(() => (showAlertModal.value = true), 1000)
    }
  }

  return {
    enviromentName,
    log,
    showAlertModal: showAlertModal,
    alertModalContent: readonly(alertModalContent)
  }
}
